export default "__VITE_ASSET__C9dg7Ia5__"